import {
  type BucketCustomization,
  type SemanticLegendSettingsWithCategoricalConfig,
} from '../../types';
import {type SemanticLegendPalette} from './colorPalettes';
import {getColorFromValue} from './getDefaultBucketColors';

export function invertColorsWithCategoricalConfig(
  semanticLegendSettings: SemanticLegendSettingsWithCategoricalConfig,
  semanticLegendPalette: SemanticLegendPalette
) {
  const newBucketCustomizations: Record<number, BucketCustomization> = {};
  const numBuckets = semanticLegendSettings?.numberOfBuckets ?? 0;
  for (let i = 0; i < numBuckets; i++) {
    const bucket = semanticLegendSettings?.buckets?.[i];
    const bucketCustomization =
      semanticLegendSettings?.bucketCustomizations?.[i];
    const color =
      bucketCustomization?.color ??
      bucket?.color ??
      getColorFromValue(i, numBuckets, semanticLegendPalette);
    newBucketCustomizations[numBuckets - 1 - i] = {
      ...semanticLegendSettings?.bucketCustomizations?.[numBuckets - 1 - i],
      color: color,
    };
  }
  return {
    ...semanticLegendSettings,
    bucketCustomizations: newBucketCustomizations,
  };
}
